import Container from '@/components/@base/container';
import localization from '@/constant/localization';
import Button from '@/components/@base/button';
import { COLOR_ENUM, VARIANT_ENUM } from '@/components/@base/@types';
import { Text } from '@/components/@base/typography';
import WalletListItem from '@/components/wallet-list-item';
import { rialPostFix } from '@/lib/helper';
import VoucherListItem from '@/components/voucher-list-item';
import arrowUp from '@/assets/icons/arrow-top.svg'
import arrowUpLight from '@/assets/icons/arrow-up-light.svg'
import useBottomSheetStore from '@/store/bottom-sheet-store';
import useUserWalletsVouchersStore from '@/store/user-wallets-store';
import { useEffect, useState } from 'react';
import useHomeStore from '@/store/home';
import cn from '@/lib/clsxm';
import { SegmentProps } from '@/components/wallets-section/types';
const AcceptSelection = ({updatedSegments}:{updatedSegments?: SegmentProps[]}) => {
  const { setShowBottomSheet } = useBottomSheetStore();
  const { remainInvoice, setIsActiveRequest } = useHomeStore();
  const { chooseValidate, segments, setSegments, usableClientVouchers, setUsableClientVouchers } = useUserWalletsVouchersStore()
  const [otherSelectionAmount, setOtherSelectionAmount] = useState(0)
  const [segmentsName, setSegmentsName] = useState('')
  useEffect(() => {
    let sumAmount = 0;
    let segmentsName = '';
    if(chooseValidate.unCombinationVouchers?.length > 1)  {
      segmentsName = localization.coupons
    } else if(chooseValidate.unCombinationVouchers?.length === 1) segmentsName = localization.coupon

    chooseValidate?.unCombinationSegments?.map((s)=>{
      sumAmount += s.balance
      if (segmentsName?.length > 0){
        segmentsName = segmentsName + ' , ' + s.upgTitle
      } else segmentsName = s.upgTitle

    })
    chooseValidate?.unCombinationVouchers?.map((v)=> {
      sumAmount += v.discountPrice
    })
    setOtherSelectionAmount(sumAmount)
    setSegmentsName(segmentsName)
  }, []);

  const handleConfirmSelection = () => {
    const copyOfSegments = updatedSegments ? updatedSegments : segments
    const copyOfVouchers = usableClientVouchers
    let unCombinationBalances = 0
    copyOfVouchers?.map(v=>{
      chooseValidate?.unCombinationVouchers?.map((uv)=> {
        if(v.voucherId === uv.voucherId) {
          if(v.usageBalance) unCombinationBalances += v.usageBalance
          v.selected = false;
          v.usageBalance = 0;
        }
      })
    })
    copyOfSegments?.map(s=>{
      chooseValidate?.unCombinationSegments?.map(us => {
        if(s.segmentId === us.segmentId) {
          if(s.usageBalance) unCombinationBalances += s.usageBalance
          s.selected = false;
          s.usageBalance = 0;
          s.isEdited = false;
        }
      })
    })

    copyOfSegments?.map(s=>{
      if(s.segmentId === chooseValidate.lastSelectedSegment?.segmentId) {
        s.selected = true;
        s.isEdited = s.usageBalance! > 0;
        s.usageBalance = s.usageBalance! > 0 ? s.usageBalance : s.balance >= (remainInvoice + unCombinationBalances) ? (remainInvoice + unCombinationBalances) : s.balance;
      }
    })
    copyOfVouchers?.map(v=>{
      if (v.voucherId === chooseValidate.lastSelectedVoucher?.voucherId) {
        v.selected = true;
        v.usageBalance = v.discountPrice >= (remainInvoice + unCombinationBalances) ? (remainInvoice + unCombinationBalances) : v.discountPrice;
      }
    })
    setSegments(copyOfSegments)
    setUsableClientVouchers(copyOfVouchers)
    setShowBottomSheet(false)
    setIsActiveRequest(false)
  }
  const handleCancelConfirm = () => {
    setShowBottomSheet(false)
    setIsActiveRequest(false)
  }
  return (
    <Container className={cn('flex flex-col items-start h-[calc(100vh-100px)] relative')}>
      {/* (!process.env.NODE_ENV || process.env.NODE_ENV !== 'production') && 'h-[calc(100vh-60px)]')}> */}
      <Container className='w-full px-4 mt-6 overflow-y-auto'>
        <Text className='text-md text-grayLight-1000 mt-1 dark:text-grayLight-0' medium> {localization.confirmSelection}</Text>
        <Text className='text-sm text-grayLight-1000 dark:text-grayLight-0 mt-1 font-medium text-justify leading-6'>
          {localization.andOtherWallets(chooseValidate.lastSelectedSegment ? chooseValidate.lastSelectedSegment.upgTitle : localization.selectedCoupon)}
          <span className='mr-1 text-grayLight-600 dark:text-grayDark-300 font-normal'>
            {localization.cantTogether(chooseValidate.lastSelectedSegment ? chooseValidate.lastSelectedSegment.upgTitle : localization.selectedCoupon, segmentsName)}
          </span></Text>
        <Container className='relative rounded-xl border border-grayLight-100 bg-grayLight-10 dark:bg-grayDark-800 dark:border-grayDark-700 flex flex-col w-full mt-4 pb-3'>
          <Container center className='border-b border-grayLight-100 dark:border-grayDark-700 px-4 py-[13px] w-full justify-between'>
            <Text className='text-grayLight-1000 dark:text-grayLight-0' medium>{chooseValidate.lastSelectedSegment ? localization.discountWith(chooseValidate.lastSelectedSegment.upgTitle): localization.discountWithCoupon}</Text>
            <Text className='text-grayLight-1000 dark:text-grayLight-0' medium>{rialPostFix(chooseValidate.lastSelectedSegment ? chooseValidate.lastSelectedSegment.balance! : chooseValidate.lastSelectedVoucher?.discountPrice!)}</Text>
          </Container>
          {chooseValidate.lastSelectedSegment && <WalletListItem data={chooseValidate.lastSelectedSegment} unUsable noBorderBottom />}
          {chooseValidate.lastSelectedVoucher && <VoucherListItem data={chooseValidate.lastSelectedVoucher} unUsable noBorderBottom/>}
          <Container center className='w-10 h-12 border-4 border-white dark:border-grayDark-600 absolute -bottom-7 left-[50%] -translate-x-1/2 bg-grayLight-10 dark:bg-grayDark-800 rounded-xl'>
            <img src={arrowUp} className='dark:hidden' alt='arrow up'/>
            <img src={arrowUpLight} className='hidden dark:block' alt='arrow up'/>
          </Container>
        </Container>

        <Container className='rounded-xl border border-grayLight-100 bg-grayLight-10 dark:bg-grayDark-800 dark:border-grayDark-700 flex flex-col w-full my-2 mb-[100px]'>
          <Container center className='border-b border-grayLight-100 dark:border-grayDark-700 px-4 pb-[13px] pt-[29px] w-full justify-between'>
            <Text className='text-grayLight-1000 dark:text-grayLight-0' medium>{localization.otherWalletsAmountSum}</Text>
            <Text className='text-grayLight-1000 dark:text-grayLight-0' medium>{rialPostFix(otherSelectionAmount)}</Text>
          </Container>
          {chooseValidate?.unCombinationSegments && chooseValidate?.unCombinationSegments?.map((item, index) => (<WalletListItem key={index} data={item} unUsable />))}
          {chooseValidate?.unCombinationVouchers && chooseValidate?.unCombinationVouchers?.map((item, index) => (<VoucherListItem data={item} key={index} unUsable />))}</Container>
      </Container>
    <Container center className='w-full h-[86px] p-4 shadow-[0_0_7px_0_#00000021] dark:shadow-[0_0_8px_0_#00000040] absolute bottom-0 bg-grayLight-0 dark:bg-grayDark-900'>
      <Button className='text-md h-[54px] w-full ml-3' onClick={handleConfirmSelection}>{localization.confirmSelection}</Button>
      <Button className='text-md h-[54px] w-full text-grayLight-1000 dark:text-grayLight-0' color={COLOR_ENUM.LIGHT_GRAY} variant={VARIANT_ENUM.OUTLINED} onClick={handleCancelConfirm}>{localization.cancelConfirm}</Button>
    </Container>
    </Container>
  )
}
export default AcceptSelection